export default __webpack_public_path__ + "static/src/companys/basic/assets/images/backgrounds/login_bg.png";